export default "/images/vendor/flag-icon-css/flags/1x1/fj.svg?55dd1c6e9a323130d8e763f7a6971c8d";